import { MultiLoadTenderResults } from "../MultiLoadTenderResults";
import { MultiSendLoadTender } from "../MultiSendLoadTender";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutMultiSendLoadTenderStepper extends Layout {
    layoutMultiLoadTenderResults: MultiLoadTenderResults;
    layoutMultiSendLoadTender: MultiSendLoadTender;
    stepSendTender: Step;
    stepTenderResults: Step;
    stepperMultiSendLoadTender: Stepper;
}
